export default function stringShorter(string, length) {
    if (string.length > length) {
        return string.substr(0, length) + '...';
    }
    return string;
}
